import { observer } from 'mobx-react-lite';
import { OsiInfoForm, OsiInfoSaveButton, OsiInfoDocs, useOsiInfoForm } from '@features/osi/info';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash';
import { OsiInfoWidgetViewModel, token as OsiInfoWidgetVmToken } from '@shared/types/mobx/widgets/OsiInfoWidget';
import { useInjection } from 'inversify-react';
import { useEffect } from 'react';
import { OsiInfoMainTabSchema } from '@shared/validation/osi/info';

export const OsiInfoWidget: React.FC = observer(() => {
  const vm = useInjection<OsiInfoWidgetViewModel>(OsiInfoWidgetVmToken);
  const { docs, formValues } = vm;
  // OSI-821: ослабленная схема — скрытые email/floors не должны блокировать «Сохранить»
  const { hookForm } = useOsiInfoForm({ defaultValues: formValues, schema: OsiInfoMainTabSchema });

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit
  } = hookForm;

  useEffect(() => {
    vm.setHookForm(hookForm);
  }, [hookForm, vm]);

  // Убрать из визарда шаг с сервисными компаниями - оставить только в ОСИ

  return (
    <Box>
      <OsiInfoForm
        lockedFields={vm.lockedFields}
        // OSI-821: email и количество этажей скрыты на вкладке для всех ролей; значения остаются в форме и уходят в payload
        hiddenFields={['email', 'floors']}
        osiUnionTypeName={vm.osiUnionTypeName}
        control={control}
        SaveButtonComponent={<OsiInfoSaveButton loading={isSubmitting} disabled={!isEmpty(errors)} />}
        DocsComponent={<OsiInfoDocs docs={docs} />}
        onSubmit={handleSubmit(vm.submitForm)}
      />
    </Box>
  );
});
